module.exports = __webpack_public_path__ + "img/calendar.19bf14b3.svg";